/**
 * Email-based identity helpers.
 *
 * Convention: one email = one user = one applicant identity = all related applications.
 * All emails are stored and compared as lowercase + trimmed.
 */

/** Normalize an email for storage and comparison. */
export function normalizeEmail(email: string | null | undefined): string {
  return (email || '').trim().toLowerCase();
}

/** Validate a normalized email is non-empty and roughly well-formed. */
export function isValidEmail(email: string): boolean {
  return email.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Build the Firestore query predicates needed to find all applications
 * belonging to a given email identity.
 *
 * Returns an array of field-value pairs to query against `applications`.
 */
export function identityQueries(email: string): Array<{ field: string; value: string }> {
  const e = normalizeEmail(email);
  return [
    { field: 'userEmail', value: e },
    { field: 'personalDetails.email', value: e },
  ];
}
